<template>
  <div class="attachments-step">
    <naj-box :title="local.attachments.title">
      <v-row>
        <v-col
          v-if="attachmentsDataArray.length > 0 || attachmentTypes.length > 0"
          class="attachments-list col col-lg-4 col-sm-12 col-12"
        >
          <attachments-list
            @show-modal="showAttachmentPanel"
            @attachmentSelected="attachmentSelected"
            @show-attachment-modal="showAttachmentModal"
          ></attachments-list>
        </v-col>

        <v-col
          v-if="showAttachmentDetailsPanel"
          class="attachment-details-main-panel col col-lg-8 col-sm-12 col-12"
        >
          <attachment-details-panel
            :attachment-type-id="attachmentTypeId"
            @show-attachment-modal="showAttachmentModal"
          ></attachment-details-panel>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-if="isEditMode"
          cols="1"
          class="mb-6"
        >
          <naj-button
            icon="mdi-plus"
            @click="showGeneralAttachmentModal"
          >
          </naj-button>
        </v-col>
      </v-row>
    </naj-box>

    <attachment-modal
      ref="attachmentModalComponent"
      :submit-loading="submitLoading"
      :attachment="selectedAttachment"
      :attachment-categories="attachmentCategories"
      :attachments-data="attachmentsDataArray"
      modal-button-text=""
      :action-text="local.attachments.addToCase"
      :attachment-type-disabled="attachmentTypeId != -1"
      @onClose="attachmentModalClosed"
      @onSubmit="submitUploadAttachment"
    ></attachment-modal>

    <requests-fees-estimation-modal
      v-if="(estimateRequests || []).length!=0"
      ref="requestsFeesEstimationModal"
      :modal-visibility="true"
      :estimate-requests="estimateRequests"
      @successSubmitPledge="feesEstimationPledgeSubmitted"
    >
    </requests-fees-estimation-modal>

    <div class="actions-buttons">
      <naj-button
        outlined
        @click="stepBack"
      >
        {{ local.common.back }}
      </naj-button>
      <naj-button
        :disabled="isViewMode || disableReplyModal || !attachmentTypesLoaded"
        @click="handleSendRequest"
      >
        {{ local.requestReply.sendRequestToCourt }}
      </naj-button>

      <naj-button
        v-if="requestInfo.requestStatusId === requestStatus.new || requestInfo.requestStatusId === requestStatus.returnToAudit"
        @click="handleSendRequestNotes"
      >
        {{ local.requestReply.cancelRequest }}
      </naj-button>

      <naj-confirmation
        :show-modal="showConfirmationModal"
        title="تأكيد"
        :message="confirmationModalMessages.message"
        ok-btn-label="نعم"
        :action-loading="submitLoading"
        @ok="sendRequestToCourt"
        @cancel="showConfirmationModal = false"
      ></naj-confirmation>

      <naj-confirmation
        :show-modal="showRemovePopup"
        color="error"
        :title="local.common.cancelConfirmation"
        :message="local.common.cancelConfirmationMessage"
        :ok-btn-label="local.common.cancel"
        @ok="removeConfirmed"
        @cancel="showRemovePopup = false"
      ></naj-confirmation>

      <naj-confirmation
        :show-modal="showVacationModal"
        :title="vacationModal.title"
        :message="vacationModal.message"
        close-btn-label="إغلاق"
        @cancel="showVacationModal = false"
      ></naj-confirmation>

      <request-notes-modal
        :form-model="formModel"
        :modal-visibility="showRequestNotesModal"
        @onCloseRequestNotesModal="handleCloseRequestNotesModel()"
      >
      </request-notes-modal>
    </div>
  </div>
</template>

<script>
import AttachmentsList from './attachments-list';
import AttachmentDetailsPanel from './attachment-details-panel';
import { requestReplyTypes, requestStatus } from '@/helpers/enum';
import AttachmentModal from '@/components/shared/attachment-modal/index';
import RequestNotesModal from '@/modules/lawsuit/components/request-reasons/request-notes.vue';
import { createNamespacedHelpers } from 'vuex';
import Vacations from '@/modules/lawsuit/services/vacations';
import RequestsFeesEstimationModal from './requests-fees-estimation-modal.vue';

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('LawsuitModule');
const { mapGetters: mapGlobalGetters } = createNamespacedHelpers('GlobalModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  components: {
    AttachmentsList,
    AttachmentModal,
    AttachmentDetailsPanel,
    RequestsFeesEstimationModal,
    RequestNotesModal,
  },
  data() {
    return {
      showRequestNotesModal: false,
      showRemovePopup: false,
      formModel: {},
      requestStatus,
      recordsModal: {},
      showVacationModal: false,
      similarRequestsExist: false,
      vacationModal: {
        title: null,
        message: null,
      },
      selectedAttachment: null,
      submitLoading: false,
      showConfirmationModal: false,
      showAttachmentDetailsPanel: false,
      attachmentTypeId: -1,
      attachmentTypesLoaded: false,

      estimateRequests: null,
    };
  },
  computed: {
    ...mapState({
      lawsuitRequestCaseData: state => state.lawsuitRequest.case,
      attachmentTypes: state => state.lawsuitRequest.attachmentTypes,
      attachmentsData: state => state.attachments.data,
      auditFields: state => state.lawsuitRequest.auditFields,
      requestInfo: state => state.submittedRequestInfo,
      disableReplyModal: state =>
        state.caseMovementReplyTypes && !state.caseMovementReplyTypes.data.length,
    }),
    ...mapGetters(['isEditMode', 'isViewMode', 'isInternalLawsuit', 'isAuditFieldsDisabled', 'isNotCompleted', 'isAttachmentsListAuditedAndShouldBeDisabled']),
    ...mapGlobalGetters(['isMohPartner']),
    ...mapLUTState(['attachmentCategories']),
    attachmentsDataArray() {
      return Object.values(this.attachmentsData);
    },
    confirmationModalMessages() {
      if (this.similarRequestsExist) {
        return { message: this.local.requestReply.sendRequestSimilarRequestsConfirmationMessage };
      }
      return { message: this.local.requestReply.sendRequestConfirmationMessage };
    },
  },
  created() {
    this.getAttachmentCategories();
    this.getLawsuitCaseAttachment();
    this.getAttachmentTypesByRequestObjectKey(this.requestInfo.objectKey).finally(() => {
      this.attachmentTypesLoaded = true;
    });
  },
  methods: {
    ...mapActions([
      'stepBack',
      'uploadAttachment',
      'getLawsuitCaseAttachment',
      'updateReplyModalVisibility',
      'updateAuditFields',
      'submitCaseReply',
      'getSimilarRequests',
      'getAttachmentTypesByRequestObjectKey',
    ]),
    ...mapLUTActions(['getAttachmentCategories']),
    submitUploadAttachment(data) {
      this.submitLoading = true;
      this.uploadAttachment(data)
        .then(() => {
          this.$refs.attachmentModalComponent.closeModal();
          this.hideAttachmentPanel();
        })
        .finally(() => (this.submitLoading = false));
    },
    attachmentModalClosed() {
      this.attachmentSelected(null);
    },
    attachmentSelected(attachment) {
      this.selectedAttachment = attachment;
      if (attachment && this.$refs.attachmentModalComponent) {
        this.$refs.attachmentModalComponent.showModal();
        this.hideAttachmentPanel();
      }
    },
    showReplyModal() {
      this.updateReplyModalVisibility({ visibility: true });
    },
    sendRequestToCourt() {
      const apiRequestBody = {
        requestObjectKey: this.requestObjectKey,
        requestReply: this.requestInfo.requestStatusId === requestStatus.draft ? requestReplyTypes.SendToCourt.id : requestReplyTypes.CompleteRequest.id,
      };
      this.submitCaseReply(apiRequestBody).then(() => {
        this.toaster.success(this.local.requestReply.sendSuccessfully);
      })
        .catch(() => {
          this.isSubmitted = false;
        })
        .finally(() => {
          this.submitLoading = false;
          this.showConfirmationModal = false;
        });
    },
    removeConfirmed() {
      const apiRequestBody = {
        requestObjectKey: this.requestObjectKey,
        requestReply: requestReplyTypes.CancelRequestByApplicant.id,
        reasons: this.formModel.reason ? [this.formModel.reason] : [this.local.caseReply.cancelReasons],
        disableRedirect: false,
      };
      this.submitCaseReply(apiRequestBody).then(() => {
        this.toaster.success(`تم ${requestReplyTypes.CancelRequest.name}`);
        this.showRequestNotesModal = false;
        this.$router.push({ path: `/` });

      })
        .finally(() => {
          this.showRemovePopup = false;
        });
    },
    showAttachmentPanel(id) {
      this.showAttachmentDetailsPanel = true;
      this.attachmentTypeId = id;
    },
    hideAttachmentPanel() {
      this.showAttachmentDetailsPanel = false;
      this.attachmentTypeId = -1;
    },
    showAttachmentModal() {
      this.$refs.attachmentModalComponent.showModal(this.attachmentTypeId);
    },
    showGeneralAttachmentModal() {
      this.hideAttachmentPanel();
      this.$refs.attachmentModalComponent.showModal();
    },
    handleSendRequest() {
      const service = Vacations.check();

      if (service.locked) {
        this.vacationModal = {
          title: 'الخدمة غير متاحة',
          message: service.message,
        };

        this.showVacationModal = true;
      } else {
        this.similarRequestsExist = false;

        if (this.isMohPartner)
          this.showConfirmationModal = true;
        else
          this.showFeesEstimationPledge();

        // this.getSimilarRequests({ params: { pageIndex: 0 } }).then(similarRequests => {
        //   if (similarRequests && similarRequests.totalCount > 0) {
        //    this.similarRequestsExist = true;
        //   }
        // }).finally(()=>{
        // });
      }
    },

    handleSendRequestNotes() {
      this.showRequestNotesModal = true;
    },
    handleCloseRequestNotesModel() {
      if (this.formModel.reason) {
        this.showRemovePopup = true;
      } else {
        this.showRequestNotesModal = false;
        this.showRemovePopup = false;
      }
    },
    feesEstimationPledgeSubmitted() {
      this.showConfirmationModal = true;
    },

    showFeesEstimationPledge() {
      this.estimateRequests =
        this.lawsuitRequestCaseData.forms[0]?.requests?.map(i => ({
          id: i.id,
          amount: i.amount,
        }));

      this.$nextTick(() => {
        var modal = this.$refs.requestsFeesEstimationModal;
        if (modal) modal.showModal();
        else this.showConfirmationModal = true;
      });

    },
  },
};
</script>

<style lang="scss">
.attachments-step {
  .attachments-list {
    border-left: 2px solid #75d6ce;
    max-height: 450px;
    overflow-y: auto;
  }
  .add-attachments-button {
    border-radius: 3px;
    padding: 3px 20px 7px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    input {
      width: 0;
      height: 0;
      font-size: 0;
      visibility: hidden;
      opacity: 0;
    }

    .add-attachment-icon {
      font-size: 24px;
    }
  }
}
.actions-buttons {
  display: flex;
  justify-content: flex-end;
}
.required-docs {
  margin-right: 20px;

  li {
    list-style: disc;
    font-size: 18px;
  }
}

// Small devices (landscape phones, 576px and up)
@media (max-width: 576px) {
  .attachment-details-main-panel {
    display: none;
  }
  .attachment-details-sub-panel {
    display: block;
  }
  .attachments-list {
    border: none !important;
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .attachment-details-main-panel {
    display: none;
  }
  .attachment-details-sub-panel {
    display: block;
  }
  .attachments-list {
    border: none !important;
  }
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .attachment-details-main-panel {
    display: block;
  }
  .attachment-details-sub-panel {
    display: none;
  }
  .attachments-list {
    border-left: 2px solid #75d6ce !important;
  }
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
  .attachment-details-main-panel {
    display: block;
  }
  .attachment-details-sub-panel {
    display: none;
  }
  .attachments-list {
    border-left: 2px solid #75d6ce !important;
  }
}
</style>
